// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__y8QlN","title":"styles_title__SsG6w","content":"styles_content__5Eqgb"};